module.exports = __webpack_public_path__ + "media/images/icons/icon-social-fb-c0ed1d20f064ebef23db6b14aed71e60.svg";